import { PrimaryButton, Stack } from "@fluentui/react";
import React from "react";

import { useDispatch, useSelector } from "react-redux";
import CafeSyncSelector from "./CafeSelector/CafeSyncSelector";
import GettingStarted from "./GettingStarted";

import { MessageBar, MessageBarType, Spinner, SpinnerSize } from "@fluentui/react";

import { syncCafeStatus } from "../common/commonConstants";
import * as diningReducer from "../reducers/diningReducer";
import * as diningSelector from "../selectors/diningSelector";
import styles from "../styles/resyncCafe.module.css";

export default () => {
  const selectedSyncCafe = useSelector(diningSelector.syncCafeSelector);
  const syncCafeAndFlushCache = useSelector(diningSelector.syncCafeAndFlushCache);
  const syncAuthorizationFailure = useSelector(diningSelector.syncAuthorizationFailure);
  const dispatch = useDispatch();

  function handleClick() {
    dispatch(diningReducer.resetSyncCafeAndFlushCacheStatus(syncCafeStatus.PROGRESS));
    if (selectedSyncCafe) {
      dispatch(diningReducer.syncCafeAndFlushCacheByIdAsync(selectedSyncCafe?.id));
    }
  }

  return (
    <Stack horizontal={true} verticalFill={true} role="main" tokens={{ childrenGap: 20 }}>
      <Stack.Item className={"cafeSelector"} verticalFill={true} grow={false}>
        <CafeSyncSelector />
      </Stack.Item>
      <Stack.Item className={"resyncCafeContent"} grow={true}>
        <Stack verticalFill={true} verticalAlign="start">
          {selectedSyncCafe ? (
            <div>
              <p>
                {syncAuthorizationFailure && (
                  <p>
                    <MessageBar messageBarType={MessageBarType.blocked} isMultiline={true}>
                      You do not have authorization to perform this action. Please reach out to
                      <a href="mailto:dwdining@microsoft.com">dwdining@microsoft.com</a> if you believe this is a
                      mistake.
                    </MessageBar>
                  </p>
                )}
                {syncCafeAndFlushCache === syncCafeStatus.ERROR && (
                  <p>
                    <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
                      Resync for <b>{selectedSyncCafe.name}</b> Failed.
                    </MessageBar>
                  </p>
                )}
                {syncCafeAndFlushCache === syncCafeStatus.SUCCESS && (
                  <p>
                    <MessageBar messageBarType={MessageBarType.success} isMultiline={false}>
                      Resync for <b>{selectedSyncCafe.name}</b> complete.
                    </MessageBar>
                  </p>
                )}
                {syncCafeAndFlushCache === syncCafeStatus.PROGRESS && !syncAuthorizationFailure && (
                  <p>
                    <div className={styles.progressBarStyle}>
                      <tr>
                        <td className={styles.spinnerStyle}>
                          <Spinner size={SpinnerSize.small} />
                        </td>
                        <td className={styles.syncTextStyle}>
                          Resync in progress. Please do not close or refresh this page.
                        </td>
                      </tr>
                    </div>
                  </p>
                )}
              </p>

              <h1>Resync </h1>
              <p>Do you want to resync this cafe&#39;s menu?</p>

              <PrimaryButton
                text="Resync"
                onClick={handleClick}
                allowDisabledFocus
                disabled={syncCafeAndFlushCache === syncCafeStatus.PROGRESS || syncAuthorizationFailure}
                checked={false}
              />
            </div>
          ) : (
            <GettingStarted
              instructions={"Then you can resync the cafe menu or edit the hours of operation and disclaimer."}
            />
          )}
        </Stack>
      </Stack.Item>
    </Stack>
  );
};
